export default __webpack_public_path__ + "static/media/flagIcon.32cabe03.svg";